import { FC, memo } from "react";

interface Props {
  title: string;
  className?: string;
}

const SectionTitleBase: FC<Props> = ({ title, className }) => {
  const classNames = [
    `relative pr-2 md:pr-3 text-[22px] md:text-xl font-bold text-center md:text-left`,
    className,
  ].join(" ");

  return <h2 className={classNames}>{title}</h2>;
};

export const SectionTitle = memo(SectionTitleBase);
